module.exports = __webpack_public_path__ + "img/logo_light.932f25d0.png";